var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"file-uploader"},[(_vm.isUploaderVisible)?_c('div',[_c('uploader',{attrs:{"moduleId":_vm.moduleId,"actionId":_vm.actionId,"id":_vm.inventoryId,"document-type-id":_vm.documentTypePhotosId,"is-file-share":_vm.isFileShare},on:{"uploadSuccess":_vm.onUploadAttachment}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }